import { api } from './_init'
import { LOADING, UPDATE, FAIL, OVERWRITE, FAIL_EMPTY } from '../reducers/default'
import { parsePartnerIntegrations } from './models'
import { returnErrorMessage } from 'utils/helpers'

//FIXME: Could be obsolete
export const fetchEventInsights = async (dispatch, eventId) => {
    dispatch({ type: LOADING })
    if (eventId) {
        try {
            const result = await api.get(`/integrations/facebook/events/${eventId}/stats`)
            
            if (result.data?.event_stats && result.data.event_stats.click_actions) {
                // the click actions array is pretty annoying to work with

                // Fix & parse the bad JSON
                const badlyFormattedActions = result.data.click_actions.replaceAll('\'', '"')
                const parsedActions = JSON.parse(badlyFormattedActions)

                // create object that makes { type_of_action: value} instead of array
                const clickActionObj = {}
                parsedActions.forEach(action => {
                    clickActionObj[action['action_type']] = action.value
                })
                result.data.click_actions = clickActionObj
            }

            dispatch({ type: UPDATE, payload: result.data })
        } catch (error) {
            dispatch({ type: FAIL })
        }
    }
}

export const fetchEventFbInsights = async (dispatch, eventId) => {
    dispatch({ type: LOADING })

    if(eventId) {
        try {
            const result = await api.get(`/integrations/facebook/events/${eventId}/fb_insights`)

            dispatch({ type: UPDATE, payload: result.data })
        } catch (error) {
            dispatch({ type: FAIL_EMPTY })
        }
    }
}

export const fetchCampaignResults = async (dispatch, eventId) => {
    dispatch({ type: LOADING })

    if(eventId) {
        try {
            const result = await api.get(`/integrations/facebook/events/${eventId}/campaign_results`)

            dispatch({ type: UPDATE, payload: result.data })
        } catch (error) {
            dispatch({ type: FAIL_EMPTY, payload: returnErrorMessage({...error, displayTextOnly: true}) })
        }
    }
}

export const fetchClientSocialPlatforms = async (dispatch) => {
    // returns an array of social platforms that a partner can use 
    // to publish an ad  created in the creative composer

    // Used in
    // FD Sales Boost > Creative Composer

    dispatch({ type: LOADING })
    try {
        const result = await api.get('/partner_integrations/')
        dispatch({ type: UPDATE, payload: parsePartnerIntegrations(result.data) })
    } catch (error) {
        dispatch({ type: FAIL })
    }
}

export const fetchAdPreviews = async (dispatch, eventId) => {
    dispatch({ type: LOADING })
    try {
        const result = await api.get(`/integrations/facebook/${eventId}/ads_previews`)
        let parsed = result.data.map((el, index) => {
            let template = document.createElement('template')
            el = el.trim()
            template.innerHTML = el
            let iframeEl = template.content.firstChild

            return {
                src: iframeEl.src,
                width: iframeEl.width,
                height: iframeEl.height,
                title: `meta-frame-${index}`
            }
        })

        dispatch({ type: UPDATE, payload: parsed })
    } catch (error) {
        dispatch({ type: FAIL })
    }
}

export const fetchPageInfos = async (dispatch, fbPageId) => {
    dispatch({ type: LOADING })

    try {
        const result = await api.get(`/integrations/facebook/page_infos?fb_page_id=${fbPageId}`)
        dispatch({ type: UPDATE, payload: result.data })
        return result.data
    } catch (error) {
        dispatch({ type: FAIL })
        return {
            error: true
        }
    }
}

export const fetchConversionGoals = async (dispatch, adAccountId) => {
    dispatch({ type: LOADING })
    
    try {
        const result = await api.get(`/integrations/connect/facebook/assets/ad_accounts/${adAccountId}/conversions`)
        dispatch({ type: OVERWRITE, payload: result.data?.items })

    } catch (error) {
        dispatch({ type: FAIL, payload: returnErrorMessage({...error, displayTextOnly: true}) })
    }
}

export const fetchAudiences = async (dispatch, adAccountId, type) => {
    dispatch({ type: LOADING })
    
    try {
        const result = await api.get(`/integrations/connect/facebook/assets/ad_accounts/${adAccountId}/audiences?type=${type}`)
        dispatch({ type: OVERWRITE, payload: result.data?.items })
    } catch (error) {
        dispatch({ type: FAIL, payload: returnErrorMessage({...error, displayTextOnly: true}) })
    }
}
